import { render } from "./ListaMarcas.vue?vue&type=template&id=57e0746c"
import script from "./ListaMarcas.js?vue&type=script&lang=js&external"
export * from "./ListaMarcas.js?vue&type=script&lang=js&external"

import "./ListaMarcas.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__